import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/studentdashboard.css";

function StudentDashboard() {
  const navigate = useNavigate();

  const [student, setStudent] = useState({});
  const [attendance, setAttendance] = useState(0);
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const studentId = localStorage.getItem("studentId");

    // Student details
    axios.get(`https://shuttle-craft-student-transport.onrender.com/api/students/${studentId}`).then((res) => {
      setStudent(res.data);
    });

    // Attendance count
    axios
      .get(`https://shuttle-craft-student-transport.onrender.com/api/attendance/student/${studentId}`)
      .then((res) => {
        setAttendance(res.data.length);
      })
      .catch(() => {});

    // Payments
    axios
      .get(`https://shuttle-craft-student-transport.onrender.com/api/payments/student/${studentId}`)
      .then((res) => {
        setPayments(res.data);
      })
      .catch(() => {});
  }, []);

  const lastPayment =
    payments.length > 0 ? payments[payments.length - 1].amount : 0;

  const paymentColor = lastPayment ? "#43e97b" : "#ff6b6b";

  return (
    <div className="main-content">
      <div className="student-navbar">Welcome {student.name} 👋</div>

      <button
        onClick={() => navigate("/pay-fees")}
        style={{
          background: "#28a745",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        Pay Monthly Fees
      </button>

      <div className="cards">
        <div className="card">
          <h3>Attendance</h3>
          <p>{attendance}</p>
          <small>Sessions Attended</small>
        </div>

        <div className="card">
          <h3>Last Payment</h3>
          <p>₹{lastPayment}</p>
          <small>{lastPayment ? "Paid" : "Pending"}</small>
        </div>

        <div className="card">
          <h3>Training Slot</h3>
          <p>{student.slot || "Not Assigned"}</p>
          <small>Coach {student.coach || "-"}</small>
        </div>
      </div>
    </div>
  );
}

export default StudentDashboard;
